import index from "../pages/index/index.vue"

export default {
  name: 'App',
  components: {
    index
  }
}